import React from 'react';

interface LegalPageProps {
  title: string;
  lastUpdated: string;
  intro?: React.ReactNode;
  children: React.ReactNode;
}

/** Shared shell for static legal documents (Privacy Policy, Terms of Service). */
export default function LegalPage({ title, lastUpdated, intro, children }: LegalPageProps) {
  return (
    <div className="bg-surface min-h-screen py-12 sm:py-16">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <header className="border-subtle mb-10 border-b pb-8">
          <h1 className="font-display text-fg text-3xl font-semibold tracking-tight sm:text-4xl">
            {title}
          </h1>
          <p className="text-fg-muted mt-3 text-sm">Last updated: {lastUpdated}</p>
          {intro && <div className="text-fg-secondary mt-4 text-base leading-relaxed">{intro}</div>}
        </header>
        <div className="space-y-10">{children}</div>
      </div>
    </div>
  );
}

interface SectionProps {
  id?: string;
  heading: string;
  children: React.ReactNode;
}

/** A numbered/anchored section within a legal document. */
export function LegalSection({ id, heading, children }: SectionProps) {
  return (
    <section id={id} className="scroll-mt-20">
      <h2 className="font-display text-fg text-xl font-semibold tracking-tight">{heading}</h2>
      <div className="text-fg-secondary mt-3 space-y-3 text-base leading-relaxed">{children}</div>
    </section>
  );
}
